import {useQuery} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient.ts'
import {httpGetMeasureGeneralRole} from '@/features/measures/services/measures.http.ts'

export const useGetGeneralRole = () => {
    return useQuery({
        queryKey: [QUERY_KEYS.MEASURE_GENERAL_ROLE],
        queryFn: httpGetMeasureGeneralRole
    })
}
